<script>
    import Icon from 'svelte-awesome';
    import {faPlusCircle, faGripLines} from '@fortawesome/free-solid-svg-icons';
    import {prettyNumber} from '../../helper/UIHelper.js';

    export let list;
    export let comp;
    let draggedDropItem;

    function dragstart (ev, elem, i) {
		ev.dataTransfer.effectAllowed = 'move';
		ev.dataTransfer.dropEffect = 'move';
		let obj = {item: elem, index: i};
   	    ev.dataTransfer.setData('text/plain', JSON.stringify(obj));
    };
    
    function dragover(ev, elem, i) {
		let obj = {item: elem, index: i};
        draggedDropItem = obj;
    }
      function dragleave() {
        draggedDropItem = null;
    }

	function drop (ev) {
        if(draggedDropItem == null)
            return;
		ev.dataTransfer.dropEffect = 'move';
        let json_obj = ev.dataTransfer.getData("text/plain");
        let obj = JSON.parse(json_obj);
        let index = obj.index;
        const item = list.splice(index,1)[0];
        delete item.draggable;
        list.splice(draggedDropItem.index, 0, item);
        sortEntries();
    };
    
     function sortEntries(){
        for(let i = 0; list.length > i; i++){
            list[i].sortPos = i;
        }
        list = list;
    }
</script>

<div on:drop|preventDefault={event => drop(event)}
		  ondragover="return false">
        {#each list as item, i}
            <div class="flex-row flex items-center mt-4 mb-4" draggable="{item.draggable}" on:dragover={event => dragover(event, item, i)} on:dragstart={event => dragstart(event, item, i)} on:dragleave={event => dragleave()}>
                <div class="mr-2 cursor-move" on:mousedown={() => {item.draggable = true}} on:mouseup={() => {item.draggable = false}}>
                    <Icon data={faGripLines} />
                </div>
	            <svelte:component bind:model={item} this={comp}/>
                <span class="flex-none ml-4">{prettyNumber(item.sortPos + 1)}</span>
            </div>
        {/each}
</div>